module.exports = __webpack_public_path__ + "img/product-list-bj.485b40c4.png";